webpackJsonp([216684635745898],{

/***/ 988:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"deck","mid_text_1":null,"sirlins_filename":"0009_forests_favor.jpg","type":"Minor Spell","subtype":"Buff","cost":2,"ATK":null,"HP":null,"rules_text_1":"Put a +1/+1 rune on a friendly unit or hero that doesn't have a +1/+1 rune.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Forest's Favor","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"The forest smiles upon thee.","color":"Green","spec":null,"bottom":"Magic","rulings":[],"keywords":[],"slug":"forests_favor"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"forests_favor","keywords":[],"imageRegex":"/forests_favor.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-forests-favor-4f704767d396798d4a49.js